import { useQuery } from '@tanstack/react-query';
import {
  getMyOrganizations,
  listOrganizations,
} from '@/modules/profile/services/accounts.service';
import type { GetOrganizationsResponse } from '../types/multi-orgs.types';

export const useGetMultiOrgs = (options?: { enabled?: boolean }) => {
  return useQuery<GetOrganizationsResponse>({
    queryKey: ['getMultiOrgs'],
    queryFn: getMyOrganizations,
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: (failureCount, error: unknown) => {
      const status = error instanceof Error ? (error as { status?: number }).status : undefined;
      if (status === 401 || status === 403) {
        return false;
      }
      return failureCount < 2;
    },
    throwOnError: false,
  });
};

/** Paginated org list for the self-signup select step — GET /organizations?Page=&PageSize=. */
export const useListOrganizations = (
  params: { page?: number; pageSize?: number } = {},
  options?: { enabled?: boolean }
) => {
  const page = params.page ?? 0;
  const pageSize = params.pageSize ?? 10;

  return useQuery<GetOrganizationsResponse>({
    queryKey: ['listOrganizations', page, pageSize],
    queryFn: () => listOrganizations({ page, pageSize }),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: (failureCount, error: unknown) => {
      const status = error instanceof Error ? (error as { status?: number }).status : undefined;
      if (status === 401 || status === 403) {
        return false;
      }
      return failureCount < 2;
    },
    throwOnError: false,
  });
};
